import type { ObjectLike } from "common/types/common-types";

type TreeNode = ObjectLike & {
  children?: TreeNode[];
};

export function getAllNodesCount(root: TreeNode) {
  let count = 0;

  function recurse(node: TreeNode) {
    count += 1;
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        recurse(child);
      }
    }
  }

  recurse(root);

  return count;
}
